import { TableColumnMeta } from "ds/components/Table/types";

export const SERVICE_NOW_TABLE_STORAGE_KEY = "serviceNowTableStorageKey";
export const SERVICE_NOW_TABLE_FILTERS_STORAGE_KEY = "serviceNowTableFiltersStorageKey";

export enum SERVICE_NOW_COLUMN_ID {
  NAME = "NAME",
  SPACE = "SPACE",
  DESCRIPTION = "DESCRIPTION",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 600;

export const SERVICE_NOW_TABLE_COLUMNS_CONFIG: Record<SERVICE_NOW_COLUMN_ID, TableColumnMeta> = {
  [SERVICE_NOW_COLUMN_ID.NAME]: {
    id: SERVICE_NOW_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [SERVICE_NOW_COLUMN_ID.SPACE]: {
    id: SERVICE_NOW_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 112,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    configurable: true,
  },
  [SERVICE_NOW_COLUMN_ID.DESCRIPTION]: {
    id: SERVICE_NOW_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 130,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    configurable: true,
  },
  [SERVICE_NOW_COLUMN_ID.DROPDOWN]: {
    id: SERVICE_NOW_COLUMN_ID.DROPDOWN,
    title: "Integration actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<SERVICE_NOW_COLUMN_ID, string> = {
  [SERVICE_NOW_COLUMN_ID.NAME]: "name",
  [SERVICE_NOW_COLUMN_ID.SPACE]: "space",
  [SERVICE_NOW_COLUMN_ID.DESCRIPTION]: "description",
  [SERVICE_NOW_COLUMN_ID.DROPDOWN]: "dropdown",
};
